import { render, staticRenderFns } from "./PhotoSlider.vue?vue&type=template&id=7bd450f7&"
import script from "./PhotoSlider.vue?vue&type=script&lang=js&"
export * from "./PhotoSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports